import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Modal } from 'semantic-ui-react';

// Global Types
import { AppState } from 'services/types';

// Actions
// @ts-ignore
import { updateQueryString } from 'services/router/actions';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
import {
    makeSelectQueryStringBooleanValue,
    makeSelectQueryStringValue,
    makeSelectQueryStringNumberValue
    // @ts-ignore
} from 'workspaces/react-router-selectors';

// Global Components
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
import RoleGate from 'components/RoleGate';
import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER
} from 'components/RoleGate/constants';

// Components
// @ts-ignore
import GroupForm from './components/GroupForm';

interface ConnectedProps {
    open: boolean;
    id?: number;
    defaultValues: any;
}

interface DispatchProps {
    updateQueryString: Function;
}

type Props = ConnectedProps & DispatchProps;

export class GroupModal extends React.PureComponent<Props> {
    handleClose = (): void => {
        this.props.updateQueryString({
            groupModal: undefined,
            defaultValues: undefined,
            selectedGroup: undefined
        });
    };

    render(): React.ReactElement {
        const { open, id, defaultValues } = this.props;

        return (
            <RoleGate requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}>
                <Modal
                    open={open}
                    onClose={this.handleClose}
                    size="fullscreen"
                    centered={false}
                    closeIcon
                >
                    <ErrorBoundary
                        namespace="GroupModal"
                        FallbackComponent={<ErrorBoundaryAlert />}
                    >
                        <GroupForm
                            groupId={id}
                            onClose={this.handleClose}
                            defaultValues={defaultValues}
                        />
                    </ErrorBoundary>
                </Modal>
            </RoleGate>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    open: makeSelectQueryStringBooleanValue('groupModal'),
    id: makeSelectQueryStringNumberValue('selectedGroup'),
    defaultValues: makeSelectQueryStringValue('defaultValues')
});

export default connect(mapStateToProps, { updateQueryString })(GroupModal);
